module.exports = __webpack_public_path__ + "img/led_screen5.eea127fe.png";